




  import { Component, namespace, Vue, Watch } from 'nuxt-property-decorator'
  import { CMS } from '@one/types'
  import qs from 'qs'

  const categories = namespace('categories')
  const cms = namespace('cms')

  type ListingQueries = string | string[]

  @Component
  export default class OneListingBanner extends Vue {
    name = 'OneListingBanner'

    @categories.Getter getSelectedCategory: any
    @cms.Getter logo: any

    bannerMatchingCurrentPath: CMS.ListingBanner | null = null
    bannersList = [] as CMS.ListingBannerList

    get currentUrl() {
      if (process.client) {
        return window.location.href
      }
      return process.env.BASE_URL ? `${process.env.BASE_URL}${this.$route.fullPath}` : ''
    }

    get currentOrigin() {
      if (process.client) {
        return window.location.origin
      }
      return process.env.BASE_URL || ''
    }

    head() {
      return {
        meta: [
          { hid: 'og:image', property: 'og:image', content: this.imageFromBanner ?? this.logo?.img ?? '' },
          { hid: 'og:url', property: 'og:url', content: this.currentUrl },
          { hid: 'og:type', property: 'og:type', content: 'website' },
          { hid: 'og:site_name', property: 'og:site_name', content: this.currentOrigin },
        ],
      }
    }

    setProductsLayout(component: string) {
      this.$emit('layout-change', component)
    }

    async fetchMatchingBanner(id: string) {
      if (!id) { return }
      try {
        const { data: banner } = await this.$api.cms.app.getBanner(id)
        this.bannerMatchingCurrentPath = banner
      } catch (error) {
        this.$logger.error(error)
      }
    }

    async compareBannerUrlWithPath() {
      const mostAccurateBanner: { id: string, matchedFiltersAmount: number } = {
        id: '',
        matchedFiltersAmount: 0,
      }

      for (const banner of this.bannersList) {
        const [bannerUrl, bannerQuery] = banner.url.split('?')
        const urlFilters = this.$route.query.filtersQuery as ListingQueries
        const bannerFilters = qs.parse(bannerQuery || '').filtersQuery as ListingQueries

        const categoriesMatch = () => {
          const currentCategory = this.getSelectedCategory
            ? this.getSelectedCategory.url
            : this.$route.path

          const bannerCategoryPath = bannerUrl.startsWith('http')
            ? new URL(bannerUrl).pathname
            : bannerUrl

          return bannerCategoryPath.endsWith(currentCategory)
        }

        const urlIncludesAllBannerFilters = (): boolean => {
          if (!bannerFilters && !urlFilters) {
            if (mostAccurateBanner.matchedFiltersAmount === 0) {
              mostAccurateBanner.id = banner.id
            }
            return true
          }
          const ensureArray = (raw: ListingQueries): string[] => Array.isArray(raw) ? raw : (raw ? [raw] : [])

          const comparableBannerFilters = ensureArray(bannerFilters)
          const comparableUrlFilters = ensureArray(urlFilters)

          if (comparableBannerFilters.length > comparableUrlFilters.length) {
            return false
          } else {
            const filterMatches = comparableUrlFilters.filter(f => comparableBannerFilters.includes(f)).length
            if (
              filterMatches === comparableBannerFilters.length &&
              mostAccurateBanner.matchedFiltersAmount <= filterMatches
            ) {
              mostAccurateBanner.id = banner.id
              mostAccurateBanner.matchedFiltersAmount = filterMatches
              return true
            }
            return false
          }
        }

        if (categoriesMatch() && urlIncludesAllBannerFilters()) {
        }
      }

      if (mostAccurateBanner.id) {
        await this.fetchMatchingBanner(mostAccurateBanner.id)
      } else {
        this.bannerMatchingCurrentPath = null
      }
    }

    get imageFromBanner() {
      if (!this.bannerMatchingCurrentPath?.html) {
        return null
      }

      const regex = /<img[^>]+src=["']([^"']+)["']/i
      const match = this.bannerMatchingCurrentPath.html.match(regex)

      if (!match) {
        return null
      }

      const extractedUrl = match[1]
      if (extractedUrl.startsWith('/')) {
        return `${this.currentOrigin}${extractedUrl}`
      }

      return extractedUrl
    }

    @Watch('$route.fullPath')
    async onRouteChange() {
      this.bannerMatchingCurrentPath = null
      await this.compareBannerUrlWithPath()
    }

    async fetch() {
      try {
        const { data: list } = await this.$api.cms.app.getBannersList()
        this.bannersList = list || []
      } catch (error) {
        this.$logger.error(error)
      } finally {
        if (this.bannersList.length) {
          await this.compareBannerUrlWithPath()
        }
      }
    }
  }
